<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 dark:text-gray-200 leading-tight">
                Create quote
            </h2>
        </template>
        <jet-select v-model:selected="selectedQuoteTemplate">
            <option :value="null">Create from template by selecting one</option>
            <option v-for="(name,id) in quoteTemplates" :key="'template-' + id" :value="id">
                {{ name }}
            </option>
        </jet-select>
        <quote-editor :client="client" :quote-themes="quoteThemes" :quote-templates="quoteTemplates"></quote-editor>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import QuoteEditor from "@/Pages/Admin/Quote/Partials/QuoteEditor";
import JetSelect from "@/Jetstream/Select";
import {inject, ref, watch} from "vue";
import {Inertia} from "@inertiajs/inertia";

export default {
    components: {
        QuoteEditor,
        AppLayout,
        JetSelect,
    },
    props: {
        client: {
            type: Object,
            required: true,
        },
        quoteThemes: {
            type: Object,
            default: {},
        },
        quoteTemplates: {
            type: Object,
            default: {},
        },
    },
    setup(props) {
        const selectedQuoteTemplate = ref(null);

        const $swal = inject('$swal');

        watch(selectedQuoteTemplate, () => {
            if (!selectedQuoteTemplate.value) {
                return;
            }
            $swal({
                title: 'Create a quote using "' + props.quoteTemplates[selectedQuoteTemplate.value] + '" template?',
                text: "You won't be able to change the template later!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, create the quote!'
            }).then((result) => {
                if (result.isConfirmed) {
                    Inertia.post(route('admin.quote.store.from-template', {client: props.client.id}), {templateId: selectedQuoteTemplate.value});
                }
                selectedQuoteTemplate.value = null;
            });
        });

        return {
            selectedQuoteTemplate,
        };
    },
}
</script>
